import { MODAL_TYPE } from "@utils/constants";
import { Button, Col, Row, Typography } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { CommonNotifyModalWrapper } from "./CommonNotifyModalStyled";

type TCommonModalProps = {
  title: React.ReactNode;
  visible: boolean;
  modalType: string;
  onClose: (value: boolean) => void;
  handleFinalAction: () => void;
  isCloseIcon: boolean;
  width: number;
  isMaskClosable: boolean;
  image?: string;
  message?: string;
  userNameRecord?: string;
  confirmLoading?: boolean;
};
const CommonNotifyModal = (props: TCommonModalProps) => {
  const { t } = useTranslation();

  const isSingleActionModalType = [
    MODAL_TYPE.SUCCESS_DELETE,
    MODAL_TYPE.SUCCESS_REGISTRATION,
    MODAL_TYPE.SUCCESS_UPDATE,
    MODAL_TYPE.FAIL_DELETE,
    MODAL_TYPE.FAIL_REGISTRATION,
    MODAL_TYPE.FAIL_UPDATE,
  ].includes(props.modalType);

  return (
    <CommonNotifyModalWrapper
      centered
      title={props.title}
      closeIcon={props.isCloseIcon}
      open={props.visible}
      onCancel={() => props.onClose(false)}
      width={props.width}
      maskClosable={props.isMaskClosable}
      footer={() => {
        return (
          <Row gutter={[8, 8]}>
            {isSingleActionModalType ? (
              <Col span={24}>
                <Button
                  onClick={() => props.onClose(false)}
                  autoInsertSpace={false}
                  className="btn-next"
                >
                  {t("COMMON.OK")}
                </Button>
              </Col>
            ) : (
              <>
                <Col span={12}>
                  <Button
                    autoInsertSpace={false}
                    className="btn-next"
                    onClick={() => props.handleFinalAction()}
                    loading={props.confirmLoading}
                  >
                    {props.modalType === MODAL_TYPE.DELETE
                      ? t("COMMON.DELETE")
                      : t("COMMON.OK")}
                  </Button>
                </Col>
                <Col span={12}>
                  <Button
                    onClick={() => props.onClose(false)}
                    autoInsertSpace={false}
                    className="cancel-btn"
                  >
                    {t("COMMON.CANCEL")}
                  </Button>
                </Col>
              </>
            )}
          </Row>
        );
      }}
    >
      <>
        <img src={props.image} alt="user_modal" />
        <div
          style={{
            marginTop: "20px",
          }}
        >
          {props.modalType === MODAL_TYPE.DELETE ? (
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <Typography
                  style={{
                    width: "100%",
                    textAlign: "center",
                    paddingBottom: "10px",
                  }}
                >
                  {props.userNameRecord}
                </Typography>
              </Col>
            </Row>
          ) : (
            <></>
          )}
          <Row>
            <Col span={24}>
              <Typography
                style={{
                  width: "100%",
                  textAlign: "center",
                  fontSize: "var(--font-size-sm)",
                }}
              >
                {props.message}
              </Typography>
            </Col>
          </Row>
        </div>
      </>
    </CommonNotifyModalWrapper>
  );
};

export { CommonNotifyModal };
